<template>
  <div class="content vacancies">

    <!-- Header -->
    <div class="content-header">
      <div class="content-header-inner">
        <div class="center-md center-xs">
          <img src="assets/static/vacancies/team/team.png"
               srcset="assets/static/vacancies/team/team@2x.png,
                       assets/static/vacancies/team/team@3x.png"
               class="content-header-image"
               alt="photo"
               width="308"
               height="325"
               loading="eager"
               fetchpriority="high"
          >
        </div>
        <div class="content-header-side">
          <div class="content-header-side-text"> {{ $t('We are not just another delivery service. We are an environment of talented people who are ready to take risks, make bold decisions and build something bigger. It is important to us to help people get everything they need: food, items, household goods, meals, pet supplies, etc. This is what we know and do best. And we do it with incredible speed. Our mission, as well as how we act and interact with each other, is driven by a strong commitment to our') }} <router-link class="content-header-side-text-link no-underline" :to="{ name: 'main-values' }"> {{ $t('CORE VALUES') }} </router-link> {{ $t('and striving to provide a friendly and safe work environment.') }}
            <br> {{ $t('Are you ready for a new, exciting stage in your life? Our team needs people like you - ambitious, persistent and pleasant to communicate with!') }}
            <br> {{ $t('We are Korzyna. And you?') }}
          </div>
          <div class="content-header-side-location">
            <p class="content-header-side-location-title"> {{ $t('Choose your city:') }} </p>
            <label for="city" style="display: none;">Виберіть країну:</label>
            <select id="city" class="content-header-side-location-listbox" v-model="selectedLocation">
              <option disabled selected value> {{ $t('Choose a city') }} </option>
              <option v-for="item in locations" :value="item.code"> {{ $t(item.name) }} </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!---->

    <!-- List -->
    <div class="content-list">

      <!-- Item -->
      <div class="content-list-inner" v-if="vacancies.length > 0">
        <vacancy v-for="item in vacancies" :ref="`vacancy-${item.id}`"
                 :key="item.id"
                 :item="item"
                 :clearVacation="clearVacation"
                 @show-vacancy-success-modal="sendApplication"
        />
      </div>
      <!---->

      <!-- Nothing -->
      <div class="content-list-nothing" v-else>
        <span class="content-list-nothing-text" v-if="!selectedLocation"> {{ $t('The city is not selected') }} </span>
        <span class="content-list-nothing-text" v-else> {{ $t('There are currently no open positions') }} </span>
      </div>
      <!---->

    </div>
    <!---->

    <!-- Modal -->
    <div class="content-modal"
         :class="{ isExist: isModalBgExist, isActive: isModalBgActive }"
         @click.self="hideModal"
    >
      <div class="content-modal-block"
           :class="{ isExist: isModalContentExist, isActive: isModalContentActive }"
      >
        <div class="content-modal-block-inner" ref="modal">
          <img src="/assets/static/vacancies/modal/modal.png"
               srcset="assets/static/vacancies/modal/modal@2x.png,
                       assets/static/vacancies/modal/modal@3x.png"
               class="content-modal-block-image"
               alt="msg-image"
               width="435"
               height="168"
               loading="eager"
               fetchpriority="high"
          >
          <h1 class="content-modal-block-title">{{ $t('Thank you') }}</h1>
          <p class="content-modal-block-text">{{ $t('Your application has been received. Wait for the call!') }}</p>
          <router-link class="content-modal-block-btn no-underline"
                       :to="{ name: 'home' }"
          >{{ $t('Return to the main page') }}</router-link>
          <button class="content-modal-block-close" @click="hideModal"></button>
        </div>
      </div>
    </div>
    <!---->

  </div>
</template>

<script>
import Vacancy from './Vacancy'

import {mapActions, mapGetters} from 'vuex'
import fetch from "isomorphic-fetch";

export default {
  components: {
    Vacancy
  },
  mounted () {
    this.$store.dispatch('partners/resetCurrentPartner')
    if (!this.selectedLocation) {
      this.selectedLocation = this.$store.getters['locations/getActiveLocation'] ? this.$store.getters['locations/getActiveLocation'].code : this.locations[0].code
    }
  },
  data () {
    return {
      // Vacancies vars
      vacancies: [],
      selectedLocation: '',

      // Modal vars
      isModalBgExist: false,
      isModalBgActive: false,
      isModalContentExist: false,
      isModalContentActive: false,
      clearVacation: { vacancyId: '', clear: false }
    }
  },
  watch: {
    selectedLocation () {
      let idx = this.locations.findIndex(el => el.code === this.selectedLocation)

      if (this.vacancies.length > 0) this.vacancies.splice(0, this.vacancies.length)

      // order by sort_position
      if (this.locations[idx].vacancies && this.locations[idx].vacancies.length) {
        this.locations[idx].vacancies.sort((a, b) => a.sort_position > b.sort_position ? 1 : -1);

        this.locations[idx].vacancies.map(vacancy => {
          if (vacancy.enabled !== 0) this.vacancies.push(vacancy)
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      locations: 'locations/getLocations'
    })
  },
  methods: {
    ...mapActions({
      sendApplicationEmail: 'vacancies/sendApplicationEmail'
    }),

    sendApplication (payload) {
      this.clearVacation.clear = false
      let vacancyId = payload.itemId
      let vacancyData = payload.vacancy_data
      let vacancyUser = payload.user_personal_data
      if (this.$refs && this.$refs[`vacancy-${vacancyId}`]) {
        let vacancy = this.$refs[`vacancy-${vacancyId}`][0]             // TODO: Fix before the deployment
        let payload = {
          application: vacancy,
          applFile: vacancy.file,
          appFileName: vacancy.fileName,
          vacancyData: vacancyData,
          userPersonalData: vacancyUser
        }
        this.sendApplicationEmail(payload).then(res => {
          if (res.code !== 200 || res.result.error) {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message: this.$t(res.result.error),
              action1: { label: this.$t('OK') }
            })
          } else {
            this.clearVacation.vacancyId = vacancyId
            this.showModal()
          }
        })
      }
    },


    // Show modal window
    showModal () {
      this.isModalBgExist = true
      this.isModalContentExist = true
      setTimeout(() => this.isModalBgActive = true, 50)
      setTimeout(() => this.isModalContentActive = true, 150)
      if (window.innerWidth <= 1200) {
        window.scrollTo(0, 0);
      }
    },

    // Hide modal window
    hideModal () {
      this.isModalContentActive = false
      setTimeout(() => this.isModalBgActive = false, 100)
      setTimeout(() => this.isModalBgExist = false, 200)
      setTimeout(() => this.isModalContentExist = false, 200)
      this.clearVacation.clear = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    width: 100%;

    /* Header */
    &-header {
      width: 100%;
      margin-bottom: 30px;

      background: #f5f5f5;

      display: flex;
      justify-content: center;

      &-inner {
        width: 1140px;
        padding: 30px 0;

        display: flex;

        @media only screen and (max-width: 1700px) {
          width: 100%;
          display: block;
          padding: 30px;
        }

        @media only screen and (max-width: 991px) {
          width: 722px;
        }

        @media only screen and (max-width: 768px) {
          width: 560px;
        }

        @media only screen and (max-width: 576px) {
          width: 100%;
          padding: 20px;

          flex-direction: column;
          align-items: center;
        }
      }

      &-image {
        width: 308px;
        height: 325px;

        padding-left: 90px;
        @media only screen and (max-width: 1700px) {
          padding-left: 0;
        }
        @media only screen and (max-width: 991px) {
          padding-left: 0;
        }

        @media only screen and (max-width: 768px) {
          width: 277px;
          height: 292px;
        }

        @media only screen and (max-width: 320px) {
          width: 100%;
          height: 100%;
        }
      }

      &-side {
        width: 100%;
        padding: 30px;
        margin-left: 20px;

        display: flex;
        flex-direction: column;
        @media only screen and (max-width: 1700px) {
          width: 100%;
          padding: 0;
          margin-left: 0;
        }
        @media only screen and (max-width: 991px) {
          padding-right: 0;
        }

        @media only screen and (max-width: 768px) {
          padding: 0;
        }

        @media only screen and (max-width: 576px) {
          margin-top: 20px;
          margin-left: 0;
        }

        &-text {
          width: 560px;
          margin: 0;

          color: #111;
          font-size: 18px;
          font-weight: 400;
          line-height: 26px;

          @media only screen and (max-width: 1700px) {
            width: 100%
          }

          @media only screen and (max-width: 991px) {
            width: 100%;
          }

          @media only screen and (max-width: 768px) {
            font-size: 16px;
            line-height: 20px;
          }

          &-link {
            color: #11bb2e;

            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }

        &-location {
          margin-top: 20px;

          display: flex;
          flex-direction: column;

          &-title {
            margin: 0;

            color: #111;
            font-size: 16px;
            font-weight: 600;
          }

          &-listbox {
            margin-top: 10px;
            padding: 0 10px;

            position: relative;
            flex: 1;

            color: #000;
            font-size: 14px;

            background-image: url('../../../../assets/static/vacancies/arrow-listbox.svg');
            background-position: 640px center;
            background-size: 10px;
            background-repeat: no-repeat;

            background-color: #fff;
            border: none;
            border-radius: 5px;
            outline: none;
            appearance: none;

            @media only screen and (max-width: 1700px) {
              background-position: 750px center;
            }
            @media only screen and (max-width: 1200px) {
              background-position: 550px center;
            }

            @media only screen and (max-width: 991px) {
              background-position: 610px center;
            }

            @media only screen and (max-width: 768px) {
              background-position: 460px center;
            }

            @media only screen and (max-width: 576px) {
              background-size: 0;
            }
          }
        }
      }
    }
    /* --- */

    /* List */
    &-list {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;

      &-inner {
        width: 1140px;
        padding: 0 20px;
        @media (max-width: 1700px) {
          width: 100%;
        }
        display: flex;
        flex-wrap: wrap;
      }

      &-nothing {
        width: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        &-text {
          color: #111;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
    /* --- */

    /* Modal */
    &-modal {
      width: 100%;
      height: 100%;
      margin: auto;

      display: none;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;

      background: transparent;
      z-index: 999;

      transition: .2s;

      &.isExist {
        display: flex;
      }

      &.isActive {
        background: rgba(0, 0, 0, .2);
      }

      &-block {
        width: 500px;
        display: none;

        background: #fff;
        border-radius: 10px;
        opacity: 0;

        transform: translateY(-150px);
        transition: .2s;

        @media only screen and (max-width: 576px) {
          width: 100%;
          height: 100%;

          border-radius: 0;
        }

        &.isExist {
          display: block;
        }

        &.isActive {
          opacity: 1;
          transform: translateY(0);
        }

        &-inner {
          padding: 20px;
          position: relative;

          display: flex;
          flex-direction: column;
          align-items: center;
        }

        &-image {
          width: 435px;
          height: 168px;
        }

        &-title {
          margin: 21px 0 0 0;

          color: #111;
          font-size: 21px;
          font-weight: 400;
        }

        &-text {
          margin: 10px 0 0 0;

          color: #111;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
        }

        &-btn {
          margin-top: 20px;
          padding: 12px 28px;

          color: #fff;
          font-size: 12px;
          font-weight: 600;

          background-color: #11bb2e;
          border-radius: 5px;
          border: none;
          outline: none;

          transition: .2s;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, .8);
          }
        }

        &-close {
          width: 20px;
          height: 20px;
          margin: auto;

          position: absolute;
          top: 20px;
          right: 20px;

          background-image: url('../../../../assets/static/vacancies/close.png');
          background-position: center;
          background-size: 17px;
          background-repeat: no-repeat;

          background-color: transparent;
          border: none;
          outline: none;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    /* --- */
  }
</style>
